

































import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import { HsabExpenseReimbursementResponse } from "@/shared/types";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import Widget from "@/shared/components/Widget.vue";

@Component({
  components: { Widget },
})
export default class AccountHolderExpenseInformationRequest extends Vue {
  formatMMddyyyyDateString = formatMMddyyyyDateString;

  @Prop()
  reimbursement: HsabExpenseReimbursementResponse;

  get hasInformationRequests (): boolean {
    return this.reimbursement
        && this.reimbursement.informationRequests
        && this.reimbursement.informationRequests.length > 0;
  }
}
